/**
 * Build-time brand colors for the handful of places that CANNOT use the CSS
 * tokens in Styles/abstracts/_tokens.scss: SVG presentation attributes
 * (fill / stroke / stop-color) and colors passed as JS string props, where
 * `var(--sm-*)` does not resolve.
 *
 * Values MUST stay in sync with the tokens in _tokens.scss. Non-StyleMatch
 * builds keep the original TrueToForm values, so other tenants are unchanged.
 */
const isStyleMatch = process.env.REACT_APP_IS_STYLEMATCH_ENV === "true";

export const BRAND_COLORS = {
  /** SM-PRIMARY (#6D1F3A). Non-SM = #066ff9 (the accent blue most SVGs used). */
  primary: isStyleMatch ? "#6d1f3a" : "#066ff9",
  /** SM-PRIMARY, for the few elements whose original blue was #0670f9 exactly
   *  (redirect bar, submitting-figure fill) — keeps those byte-identical. */
  primary0670: isStyleMatch ? "#6d1f3a" : "#0670f9",
  /** Light tint of primary — figure base, unselected checklist borders */
  primaryTint: isStyleMatch ? "#e8dde1" : "#d9e4fe",
  /** SM-SUCCESS (#2E7D4F) */
  success: isStyleMatch ? "#2e7d4f" : "#00a931",
  /** SM-ERROR (#B3261E) */
  error: isStyleMatch ? "#b3261e" : "#ff627e",
  /** ~12% primary — selected checklist-row background */
  primaryFaint: isStyleMatch ? "#6d1f3a1f" : "#5398ff1f",
};
